import React from "react";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import AriaTooltip from "../../../../../Shared/Tooltip/AriaTooltip";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { CustomerSearchAction } from "../../ClientRecord/Action/CustomerSearchAction";

interface ICustomerDetailsPopUpProps {
    customerId: number;
    displayText: string;
}

export const CustomerDetailsPopup = (props: ICustomerDetailsPopUpProps) => {
    if (!props.customerId) {return null;}

    const [customerAge, setCustomerAge] = React.useState("Not held");
    const [taxIdentifier, setTaxIdentifier] = React.useState("Not held");
    const [emailAddress, setEmailAddress] = React.useState("Not held");
    const [postCode, setPostCode] = React.useState("Not held");
    const [isLoading, setIsLoading] = React.useState(true);

    const getCustomerDetail = (customerId: number) => {
        setIsLoading(true);
        CustomerSearchAction.getCustomerData(customerId, (result) => {
            if (result?.CustomerTaxResidencyDetails != null && result?.CustomerTaxResidencyDetails.length > 0) {
                setTaxIdentifier(result?.CustomerTaxResidencyDetails[0].TaxReference);
            }
            if (result?.PersonalDetails?.DateOfBirth != null) {
                setCustomerAge(JsonDateParser.calculateAge(result?.PersonalDetails.DateOfBirth).toString());
            }
            if (result?.EmailAddressDetails != null && result?.EmailAddressDetails.length > 0) {
                setEmailAddress(result?.EmailAddressDetails?.[0]?.EmailAddress);
            }
            if (result?.AddressDetails != null && result?.AddressDetails.length > 0) {
                setPostCode(result?.AddressDetails[0].Address.PostCode);
            }
            setIsLoading(false);
        });
    };

    const tooltipConfig = () => {
        return [
            {
                title: "Client age",
                data: customerAge,
            },
            {
                title: (
                    <span>
                        Tax /<br />
                        Government Identifier
                    </span>
                ),
                data: taxIdentifier,
            },
            { title: "Post code", data: postCode },
            { title: "Email address", data: emailAddress },
        ];
    };

    return (
        <AriaTooltip
            cssWrapper="is-underlined-text"
            buttonText={props.displayText}
            onClick={() => {
                getCustomerDetail(props.customerId);
            }}
            showCloseButton={true}
            onClose={() => {
                setTaxIdentifier("Not held");
                setCustomerAge("Not held");
                setPostCode("Not held");
                setEmailAddress("Not held");
            }}
            isLoading={isLoading}
        >
            <Typography type="auto-width" wrapCss="mt-5 mb-0" config={tooltipConfig()} />
        </AriaTooltip>
    );
};
